import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement } from "@wordpress/element";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/** @format */

/**
 * External dependencies
 */
import { __ } from '@wordpress/i18n';
import { Component, createRef } from '@wordpress/element';
import { SelectControl, Button, Dropdown, IconButton } from '@wordpress/components';
import { partial, findIndex, difference, isEqual } from 'lodash';
import PropTypes from 'prop-types';
import Gridicon from 'gridicons';
import interpolateComponents from 'interpolate-components';
import classnames from 'classnames';
/**
 * WooCommerce dependencies
 */

import { getActiveFiltersFromQuery, getDefaultOptionValue, getNewPath, getQueryFromActiveFilters, getHistory } from '@woocommerce/navigation';
/**
 * Internal dependencies
 */

import Card from '../card';
import Link from '../link';
import SelectFilter from './select-filter';
import SearchFilter from './search-filter';
import NumberFilter from './number-filter';
import DateFilter from './date-filter';
var matches = [{
  value: 'all',
  label: __('All', 'woocommerce-admin')
}, {
  value: 'any',
  label: __('Any', 'woocommerce-admin')
}];
/**
 * Displays a configurable set of filters which can modify query parameters.
 */

var AdvancedFilters =
/*#__PURE__*/
function (_Component) {
  _inherits(AdvancedFilters, _Component);

  function AdvancedFilters(_ref) {
    var _this;

    var query = _ref.query,
        config = _ref.config;

    _classCallCheck(this, AdvancedFilters);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AdvancedFilters).apply(this, arguments));
    _this.state = {
      match: query.match || 'all',
      activeFilters: getActiveFiltersFromQuery(query, config.filters)
    };
    _this.filterListRef = createRef();
    _this.onMatchChange = _this.onMatchChange.bind(_assertThisInitialized(_this));
    _this.onFilterChange = _this.onFilterChange.bind(_assertThisInitialized(_this));
    _this.getAvailableFilterKeys = _this.getAvailableFilterKeys.bind(_assertThisInitialized(_this));
    _this.addFilter = _this.addFilter.bind(_assertThisInitialized(_this));
    _this.removeFilter = _this.removeFilter.bind(_assertThisInitialized(_this));
    _this.clearFilters = _this.clearFilters.bind(_assertThisInitialized(_this));
    _this.getUpdateHref = _this.getUpdateHref.bind(_assertThisInitialized(_this));
    _this.updateFilter = _this.updateFilter.bind(_assertThisInitialized(_this));
    _this.onFilter = _this.onFilter.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(AdvancedFilters, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          config = _this$props.config,
          query = _this$props.query;
      var prevQuery = prevProps.query;

      if (!isEqual(prevQuery, query)) {
        /* eslint-disable react/no-did-update-set-state */
        this.setState({
          activeFilters: getActiveFiltersFromQuery(query, config.filters)
        });
        /* eslint-enable react/no-did-update-set-state */
      }
    }
  }, {
    key: "onMatchChange",
    value: function onMatchChange(match) {
      var onAdvancedFilterAction = this.props.onAdvancedFilterAction;
      this.setState({
        match: match
      });
      onAdvancedFilterAction('match', {
        match: match
      });
    }
  }, {
    key: "onFilterChange",
    value: function onFilterChange(key, property, value) {
      var activeFilters = this.state.activeFilters.map(function (activeFilter) {
        if (key === activeFilter.key) {
          return Object.assign({}, activeFilter, _defineProperty({}, property, value));
        }

        return activeFilter;
      });
      this.setState({
        activeFilters: activeFilters
      });
    }
  }, {
    key: "updateFilter",
    value: function updateFilter(filter) {
      var activeFilters = this.state.activeFilters.map(function (activeFilter) {
        if (filter.key === activeFilter.key) {
          return filter;
        }

        return activeFilter;
      });
      this.setState({
        activeFilters: activeFilters
      });
    }
  }, {
    key: "removeFilter",
    value: function removeFilter(key) {
      var onAdvancedFilterAction = this.props.onAdvancedFilterAction;

      var activeFilters = _toConsumableArray(this.state.activeFilters);

      var index = findIndex(activeFilters, function (filter) {
        return filter.key === key;
      });
      onAdvancedFilterAction('remove', activeFilters[index]);
      activeFilters.splice(index, 1);
      this.setState({
        activeFilters: activeFilters
      });

      if (0 === activeFilters.length) {
        var history = getHistory();
        history.push(this.getUpdateHref([]));
      }
    }
  }, {
    key: "getTitle",
    value: function getTitle() {
      var match = this.state.match;
      var config = this.props.config;
      return interpolateComponents({
        mixedString: config.title,
        components: {
          select: createElement(SelectControl, {
            className: "woocommerce-filters-advanced__title-select",
            options: matches,
            value: match,
            onChange: this.onMatchChange,
            "aria-label": __('Choose to apply any or all filters', 'woocommerce-admin')
          })
        }
      });
    }
  }, {
    key: "getAvailableFilterKeys",
    value: function getAvailableFilterKeys() {
      var config = this.props.config;
      var activeFilterKeys = this.state.activeFilters.map(function (f) {
        return f.key;
      });
      return difference(Object.keys(config.filters), activeFilterKeys);
    }
  }, {
    key: "addFilter",
    value: function addFilter(key, onClose) {
      var _this2 = this;

      var _this$props2 = this.props,
          onAdvancedFilterAction = _this$props2.onAdvancedFilterAction,
          config = _this$props2.config;
      var filterConfig = config.filters[key];
      var newFilter = {
        key: key
      };

      if (Array.isArray(filterConfig.rules) && filterConfig.rules.length) {
        newFilter.rule = filterConfig.rules[0].value;
      }

      if (filterConfig.input && filterConfig.input.options) {
        newFilter.value = getDefaultOptionValue(filterConfig, filterConfig.input.options);
      }

      if (filterConfig.input && 'Search' === filterConfig.input.component) {
        newFilter.value = '';
      }

      this.setState(function (state) {
        return {
          activeFilters: [].concat(_toConsumableArray(state.activeFilters), [newFilter])
        };
      });
      onAdvancedFilterAction('add', newFilter);
      onClose(); // after render, focus the newly added filter's first focusable element

      setTimeout(function () {
        var addedFilter = _this2.filterListRef.current.querySelector('li:last-of-type fieldset');

        addedFilter.focus();
      });
    }
  }, {
    key: "clearFilters",
    value: function clearFilters() {
      var onAdvancedFilterAction = this.props.onAdvancedFilterAction;
      onAdvancedFilterAction('clear_all');
      this.setState({
        activeFilters: [],
        match: 'all'
      });
    }
  }, {
    key: "getUpdateHref",
    value: function getUpdateHref(activeFilters, matchValue) {
      var _this$props3 = this.props,
          path = _this$props3.path,
          query = _this$props3.query,
          config = _this$props3.config;
      var updatedQuery = getQueryFromActiveFilters(activeFilters, query, config.filters);
      var match = matchValue === 'all' ? undefined : matchValue;
      return getNewPath(_objectSpread({}, updatedQuery, {
        match: match
      }), path, query);
    }
  }, {
    key: "isEnglish",
    value: function isEnglish() {
      return /en[-|_]/.test(this.props.siteLocale);
    }
  }, {
    key: "onFilter",
    value: function onFilter() {
      var _this$props4 = this.props,
          onAdvancedFilterAction = _this$props4.onAdvancedFilterAction,
          query = _this$props4.query,
          config = _this$props4.config;
      var _this$state = this.state,
          activeFilters = _this$state.activeFilters,
          match = _this$state.match;
      var updatedQuery = getQueryFromActiveFilters(activeFilters, query, config.filters);
      onAdvancedFilterAction('filter', _objectSpread({}, updatedQuery, {
        match: match
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props5 = this.props,
          config = _this$props5.config,
          query = _this$props5.query,
          currency = _this$props5.currency;
      var _this$state2 = this.state,
          activeFilters = _this$state2.activeFilters,
          match = _this$state2.match;
      var availableFilterKeys = this.getAvailableFilterKeys();
      var updateHref = this.getUpdateHref(activeFilters, match);
      var updateDisabled = 'admin.php' + window.location.search === updateHref || 0 === activeFilters.length;
      var isEnglish = this.isEnglish();
      return createElement(Card, {
        className: "woocommerce-filters-advanced woocommerce-analytics__card",
        title: this.getTitle()
      }, createElement("ul", {
        className: "woocommerce-filters-advanced__list",
        ref: this.filterListRef
      }, activeFilters.map(function (filter) {
        var key = filter.key;
        var _config$filters$key = config.filters[key],
            input = _config$filters$key.input,
            labels = _config$filters$key.labels;
        return createElement("li", {
          className: "woocommerce-filters-advanced__list-item",
          key: key
        }, 'SelectControl' === input.component && createElement(SelectFilter, {
          className: "woocommerce-filters-advanced__fieldset-item",
          filter: filter,
          config: config.filters[key],
          onFilterChange: _this3.onFilterChange,
          isEnglish: isEnglish
        }), 'Search' === input.component && createElement(SearchFilter, {
          className: "woocommerce-filters-advanced__fieldset-item",
          filter: filter,
          config: config.filters[key],
          onFilterChange: _this3.onFilterChange,
          isEnglish: isEnglish,
          query: query
        }), 'Number' === input.component && createElement(NumberFilter, {
          className: "woocommerce-filters-advanced__fieldset-item",
          filter: filter,
          config: config.filters[key],
          onFilterChange: _this3.onFilterChange,
          isEnglish: isEnglish,
          query: query,
          currency: currency
        }), 'Currency' === input.component && createElement(NumberFilter, {
          className: "woocommerce-filters-advanced__fieldset-item",
          filter: filter,
          config: _objectSpread({}, config.filters[key], {}, {
            input: {
              type: 'currency',
              component: 'Currency'
            }
          }),
          onFilterChange: _this3.onFilterChange,
          isEnglish: isEnglish,
          query: query,
          currency: currency
        }), 'Date' === input.component && createElement(DateFilter, {
          className: "woocommerce-filters-advanced__fieldset-item",
          filter: filter,
          config: config.filters[key],
          onFilterChange: _this3.onFilterChange,
          isEnglish: isEnglish,
          query: query,
          updateFilter: _this3.updateFilter
        }), createElement(IconButton, {
          className: classnames('woocommerce-filters-advanced__line-item', 'woocommerce-filters-advanced__remove'),
          label: labels.remove,
          onClick: partial(_this3.removeFilter, key),
          icon: createElement(Gridicon, {
            icon: "cross-small"
          })
        }));
      })), availableFilterKeys.length > 0 && createElement("div", {
        className: "woocommerce-filters-advanced__add-filter"
      }, createElement(Dropdown, {
        className: "woocommerce-filters-advanced__add-filter-dropdown",
        position: "bottom center",
        renderToggle: function renderToggle(_ref2) {
          var isOpen = _ref2.isOpen,
              onToggle = _ref2.onToggle;
          return createElement(IconButton, {
            className: "woocommerce-filters-advanced__add-button",
            icon: createElement(Gridicon, {
              icon: "add-outline"
            }),
            onClick: onToggle,
            "aria-expanded": isOpen
          }, __('Add a Filter', 'woocommerce-admin'));
        },
        renderContent: function renderContent(_ref3) {
          var onClose = _ref3.onClose;
          return createElement("ul", {
            className: "woocommerce-filters-advanced__add-dropdown"
          }, availableFilterKeys.map(function (key) {
            return createElement("li", {
              key: key
            }, createElement(Button, {
              onClick: partial(_this3.addFilter, key, onClose)
            }, config.filters[key].labels.add));
          }));
        }
      })), createElement("div", {
        className: "woocommerce-filters-advanced__controls"
      }, updateDisabled && createElement(Button, {
        isPrimary: true,
        disabled: true
      }, __('Filter', 'woocommerce-admin')), !updateDisabled && createElement(Link, {
        className: "components-button is-primary is-button",
        type: "wc-admin",
        href: updateHref,
        onClick: this.onFilter
      }, __('Filter', 'woocommerce-admin')), activeFilters.length > 0 && createElement(Link, {
        type: "wc-admin",
        href: this.getUpdateHref([]),
        onClick: this.clearFilters
      }, __('Clear all filters', 'woocommerce-admin'))));
    }
  }]);

  return AdvancedFilters;
}(Component);

AdvancedFilters.propTypes = {
  /**
   * The configuration object required to render filters.
   */
  config: PropTypes.shape({
    title: PropTypes.string,
    filters: PropTypes.objectOf(PropTypes.shape({
      labels: PropTypes.shape({
        add: PropTypes.string,
        remove: PropTypes.string,
        rule: PropTypes.string,
        title: PropTypes.string,
        filter: PropTypes.string
      }),
      rules: PropTypes.arrayOf(PropTypes.object),
      input: PropTypes.object
    }))
  }).isRequired,

  /**
   * Name of this filter, used in translations.
   */
  path: PropTypes.string.isRequired,

  /**
   * The query string represented in object form.
   */
  query: PropTypes.object,

  /**
   * Function to be called after an advanced filter action has been taken.
   */
  onAdvancedFilterAction: PropTypes.func,

  /**
   * The locale for the site.
   */
  siteLocale: PropTypes.string,

  /**
   * The currency formatting instance for the site.
   */
  currency: PropTypes.object.isRequired
};
AdvancedFilters.defaultProps = {
  query: {},
  onAdvancedFilterAction: function onAdvancedFilterAction() {},
  siteLocale: 'en_US'
};
export default AdvancedFilters;
//# sourceMappingURL=index.js.map